export default function portalSettings (Restangular) {
  'ngInject'
  return {
    user: Restangular.all('portal-settings/user'),
    campaign: Restangular.all('portal-settings/campaign')
  }
}
